var render, staticRenderFns
import script from "./SlideGroup.vue?vue&type=script&lang=js&"
export * from "./SlideGroup.vue?vue&type=script&lang=js&"
import style0 from "./SlideGroup.vue?vue&type=style&index=0&id=29607a9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29607a9f",
  null
  
)

export default component.exports